<!-- @format -->

<header>
  <nav class="navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" href="#">
      <img src="/assets/images/dnv-logo.png" title="District Of North Vancouver" />
    </a>
    <h1>Timesheet App</h1>
    @if (isTestEnv) {
      <span class="testEnvHeading">UAT Environment</span>
    }

    <div class="imageIconContainer" [class.noBorder]="profileImg" ngbDropdown>
      <button ngbDropdownToggle class="imageIconContainer">
        @if (profileImg) {
          <ng-container [class.noBorder]="profileImg">
            <img class="profile_icon" src="{{base64ProfilePhoto}}" />
          </ng-container>
        }

        @if (!profileImg) {
          <div [class.noBorder]="profileImg">
            <i class="fa-solid fa-user" data-fa-transform="down-2" data-fa-mask="fa-solid fa-circle"></i>
          </div>
        }
      </button>

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-end">
        <button ngbDropdownItem [routerLink]='["/profile"]' [class.active]="isCurrentActiveRoute('/profile')">Profile</button>
        @if (isManagerOrTimeKeeper()) {
          <button
            ngbDropdownItem
            [routerLink]='["/team-profiles"]'
            [class.active]="isCurrentActiveRoute('/team-profiles')"
            >
            Team Profiles
          </button>
        }
        @if (isAdmin()) {
          <button ngbDropdownItem [routerLink]='["/accounts"]' [class.active]='isCurrentActiveRoute("/accounts")'>
            Accounts
          </button>
        }
        <button ngbDropdownItem [routerLink]='["/logout"]'>Log out</button>
      </div>
    </div>
  </nav>
</header>
<!-- <app-nav-menu *ngIf="router.url !== '/accessdenied'" [role]="role" [isDelegatedAsManager]="isDelegatedAsManager" [isLoadingData]="isLoadingData"></app-nav-menu> -->
@if (router.url !== '/accessdenied') {
  <app-nav-menu [role]="role" [isLoadingData]="isLoadingData"></app-nav-menu>
}
